module.exports = __webpack_public_path__ + "static/media/group.b47ad856.svg";